// Module-level holder for the non-serializable, shared handles that formerly lived in
// WorkRefsContext (React Context). These are plain mutable refs + one class instance (classObj) —
// they cannot go in Redux (non-serializable, mutated in place). This is NOT React Context; it's a
// singleton imported directly. Since only one WorkDetail tree is mounted at a time, a single shared
// set matches the old context's "one instance per tree" behavior. Ref-object identities are stable
// (only `.current` mutates), so components can rely on them across renders.

export const workRefs = {
  qrRef: { current: undefined },
  thumbRef: { current: undefined },
  moreRef: { current: undefined },
  likeViewRef: { current: null },
  scrollContainerRef: { current: null },
  thumbState: { current: false },
  carouselRef: { current: null },
  storyRef: { current: null },
  dropdownRef: { current: null },
  shareRef: { current: null },
  zoomRef: { current: window.devicePixelRatio },
  divRef: { current: null },
  popupRef: { current: null },
  firstCheck: { current: true },
  firstCheckMedia: { current: true },
  viewTimeoutRef: { current: null },
  nicknameInput: { current: null },
  isSelecting: { current: false },
  newCreatedFolder: { current: false },
};

// classObj holds a `selectionMode` class instance (see script/SelectionMode.js). Read at call-time
// via getClassObj() so consumers never capture a stale value; written via setClassObj().
let classObj;
export const getClassObj = () => classObj;
export const setClassObj = (value) => { classObj = value; };

// Restore the logic-flag refs + classObj to their initial values. Called when the WorkDetail
// subtree mounts, replicating the old nested-provider behavior of fresh useRef() per visit.
// (DOM refs are auto-nulled on unmount and reattached on mount by React, so they need no reset.)
export function resetWorkRefs() {
  workRefs.thumbState.current = false;
  workRefs.firstCheck.current = true;
  workRefs.firstCheckMedia.current = true;
  workRefs.isSelecting.current = false;
  workRefs.newCreatedFolder.current = false;
  workRefs.zoomRef.current = window.devicePixelRatio;
  classObj = undefined;
}
